export const PRIVACY_POLICY = `
Privacy Policy
PRIVACY POLICY STATEMENT
FOR
Johnston’s Grain Connected Ltd.
This Privacy Policy describes how Johnston’s Grain Connected Ltd. ("we," "us," or "our") collects, uses,
and discloses personal information when you use our services or interact with us. We are committed to
maintaining the accuracy, confidentiality, and security of your personal information. As part of this
commitment, our privacy policy governs our actions as they relate to the collection, use and disclosure of
personal information.
1. Identifying Purposes
We may collect, use and disclose some personal information from you such as name, address, email,
phone etc. to provide you with the product or service you have requested and to offer you additional
products and services we believe you might be interested in. The purposes for which we collect personal
information will be identified before or at the time we collect the information. In certain circumstances,
the purposes for which information is collected may be clear, and consent may be implied, such as where
your name, address and payment information is provided as part of the order process.
2. How we utilise your information
You may be required to submit personal information in order to create your account set up and assist with
the functioning of the platform. This information will also be used to help us with contacting and
communicating with you. It will also mean that you will not be required to re-enter the information when
using the functions of our platform. The information will also be used for billing purposes.
3. Data Sharing and Disclosure
We may share your personal information with:
• Third-party service providers who assist us in operating our business (e.g., payment
processors, shipping companies)
• Law enforcement or government agencies when required by law or to protect our rights
• Other third parties with your consent or as otherwise permitted by law
4. Consent
Knowledge and consent are required for the collection, use or disclosure of Personal Information except
where required or permitted by law. Providing us with your Personal Information is always your choice.
However, your decision not to provide certain information may limit our ability to provide you with our
products or services. We will not require you to consent to the collection, use, or disclosure of
information as a condition to the supply of a product or service, except as required to be able to supply the
product or service.

5. Limiting Use, Disclosure and Retention
Personal Information may only be used or disclosed for the purpose for which it was collected unless you
have otherwise consented, or when it is required or permitted by law. Personal Information will only be
retained for the period of time required to fulfill the purpose for which we collected it or as may be
required by law.
6. Accuracy
Personal Information will be maintained in as accurate, complete and up-to-date form as is necessary to
fulfill the purposes for which it is to be used.
7. Safeguarding Customer Information
Personal Information will be protected by security safeguards that are appropriate to the sensitivity level
of the information. We take all reasonable precautions to protect your Personal Information from any loss
or unauthorized use, access or disclosure.
8. Customer Access
You may verify the accuracy and completeness of your Personal Information, and may request that it be
amended, if appropriate..
9. Contact Us
You may direct any questions or enquiries with respect to our privacy policy or our practices by
contacting: support@johnstonsconnected.com
Additional Information
Cookies
A cookie is a small computer file or piece of information that may be stored in your computer's hard drive
when you visit our websites. We may use cookies to improve our website’s functionality and in some
cases, to provide visitors with a customized online experience. Cookies are widely used and most web
browsers are configured initially to accept cookies automatically. Please note, however, if you disable
cookies, you may not experience optimal performance of our website.
Our website may contain links to other third party sites that are not governed by this privacy policy. We
take no responsibility for the privacy policies of these sites or how they handle information. Therefore, we
suggest that you examine the privacy statements of those sites to learn how your information may be
collected, used, shared and disclosed.
`;

export const TERMS_OF_USE = `
Terms of Use for Johnston’s Grain Connected Ltd. Online Trading Platform
Please read the terms and conditions carefully before using our platform.
1. Acceptance of Terms
These Terms and Conditions constitute a legally binding agreement made between you, whether
personally or on behalf of an entity (“you”) and JOHNSTON’S GRAIN CONNECTED LTD. (“we,” “us”
or “our”), concerning your access to and use of the Johnston’s Online Trading Platform application as
well as any other media form, media channel, mobile website or mobile application related, linked, or
otherwise connected thereto (collectively, the “Platform” or “Site”). You agree that by accessing the Site,
you have read, understood, and agree to be bound by all of these Terms and Conditions (“Terms of Use”).
Please note, if you do not agree with all of these terms and conditions, then you are expressly prohibited
from using the platform.
Additional terms and conditions or documents that may be posted within the Platform from time to time
are hereby expressly incorporated herein by reference. We reserve the right, at our sole discretion, to make
changes or modifications to these Terms and Conditions at any time and for any reason. We will alert you
about any changes by updating the “Last updated” date of these Terms and Conditions and you waive any
right to receive specific notice of each such change. It is your responsibility to periodically review these
Terms and Conditions to stay informed of updates. You will be subject to and will be deemed to have been
made aware of and to have accepted, the changes in any revised Terms and Conditions by your continued
use of the Platform after the date such revised Terms are posted.
The information provided on the Platform is not intended for distribution to or use by any person or entity
in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which
would subject us to any registration requirement within such jurisdiction or country. Accordingly, those
persons who choose to access the Platform from other locations do so on their own initiative and are solely
responsible for compliance with local laws, if and to the extent local laws are applicable.
2. Description of Service
Johnston’s Grain Connected Ltd. provides an online trading platform that allows users to connect
approved buyers and sellers so that they may agree to transact on agricultural and other goods.
Buyers and sellers can both, post offers through the phone application, the Johnston’s Online
website or by directly communicating with a Johnston’s broker.
3. User Eligibility
You must be at least 18 years old and legally capable of entering into contracts to use the
Johnston’s Connected platform. By using our platform, you represent and warrant that you meet
these eligibility requirements.
4. Registration and Accounts
a. To access certain features of Johnston’s Connected Platform, you may be required to register for an
account. You agree to provide accurate, current, and complete information during the registration process.
b. You are responsible for maintaining the confidentiality of your account credentials and for all activities
that occur under your account. c. Johnston’s Connected reserves the right to suspend or terminate your
account if any information provided during the registration process is inaccurate, incomplete, or
misleading.
Seller Listings, you agree to the following;
1. to only post seller listings and make sales transactions under the following conditions:
a) Irrespective of the other conditions in this list, you are operating in good faith always.
b) You are forbidden from listing products for sale that does not exist or grain that you know will
not be available for the buyer on the agreed date(s).
c) You are forbidden from purposefully mis-construing the: quality, variety, origin, quantity,
organic status or any other attribute of the product that is material to its sale.
d) Estimates are permissible if disclosed at time of listing.
2. that if the product you listed has been damaged, destroyed, repossessed or otherwise made
unavailable or materially different from the listing that you will inform as soon as possible:
a) Johnston’s Grain Connected Ltd. only if the product has been listed but not transacted upon or
b) Both Johnston’s Grain Connected Ltd. and the product’s buyer if the product has been
purchased.
3. that virtual signatures on electronic documents made on the Platform, or as a result of the Platform,
are the equivalent of a signed paper document.
4. to only list products that you own or have capacity to purchase, or the products of an owner who
has given you explicit, written permission to transact on their behalf.
Purchaser Listings, you agree to the following;
1.to only post buyer listings and make purchase transactions under the following conditions:
a) Irrespective of the other conditions in this list, you are operating in good faith always.
b) You are forbidden from listing a bid to purchase products that you: do not intend to purchase
if offered, if you could not accept/order delivery during the time period offered, if you are
insolvent or have any reason to think that you may be unable to pay the agreed price for the
product or if there is any other impediment you are aware of that would prevent the fulfillment
of the contract as offered.
2. You agree that if you become aware of any circumstance that would prevent the fulfillment of a
contract negotiated on the Johnston’s Platform that you will report that finding to us and the seller
as soon as possible.
3. If there is a discrepancy on grade/quality with the seller you will inform Johnston’s as soon as
possible after you become aware of that situation.
4. that virtual signatures on electronic documents made on the Platform, or as a result of the Platform,
are the equivalent of a signed paper document.
Please also be reminded that Johnston’s Connected reserves the right to pause or deactivate your account if
there is no activity on it for 30 consecutive days, we hope this will not be necessary.
5. Prohibited Activities and Transaction Rules
You may not access or use the Platform for any purpose other than that for which we make the Platform
available. The Platform may not be used in connection with any commercial endeavors except those that
are specifically endorsed or approved by us.
As a user of the Platform, you agree not to:
1. systematically retrieve data or other content from the Platform to create or compile, directly
or indirectly, a collection, compilation, database, or directory without written permission
from us.
2. make any unauthorized use of the Platform, including but not limited to collecting usernames
and/or email addresses of users by electronic or other means for the purpose of sending
unsolicited email, or creating user accounts by automated means or under false pretenses.
3. engage in unauthorized framing of or linking to the Platform.
4. trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive
account information such as user passwords;
5. attempt to impersonate another user or person or use the username of another user.
6. use a buying agent or purchasing agent to make purchases on the Platform.
7. use the Platform to advertise or offer to sell goods and services.
8. circumvent, disable, or otherwise interfere with security-related features of the Platform,
including features that prevent or restrict the use or copying of any Content or enforce
limitations on the use of the Platform and/or the Content contained therein.
9. sell or otherwise transfer your profile.
10. use any information obtained from the Platform in order to harass, abuse, or harm another
person.
11. use the Platform as part of any effort to compete with us or otherwise use the Platform and/or
the Content for any revenue-generating endeavor or commercial enterprise.
12. decipher, decompile, disassemble, or reverse engineer any of the software comprising or in
any way making up a part of the Platform.
13. attempt to bypass any measures of the Platform designed to prevent or restrict access to the
Platform, or any portion of the Platform.
14. copy or adapt the Platform’s software, including but not limited to Flash, PHP, HTML,
JavaScript, or other code.
15. harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing
any portion of the Platform to you.
16. delete the copyright or other proprietary rights notice from any Content.
17. upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other
material, including excessive use of capital letters and spamming (continuous posting of
repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the
Platform or modifies, impairs, disrupts, alters, or interferes with the use, features, functions,
operation, or maintenance of the Site.
18. upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or
active information collection or transmission mechanism, including without limitation, clear
graphics interchange formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices
(sometimes referred to as “spyware” or “passive collection mechanisms” or “pcms”).
19. disparage, tarnish, or otherwise harm, in our opinion, us and/or the Platform.
20. use the Platform in a manner inconsistent with any applicable laws or regulations.
21. make improper use of our support services or submit false reports of abuse or misconduct.
22. engage in any automated use of the system, such as using scripts to send comments or
messages, or using any data mining, robots, or similar data gathering and extraction tools.
23. interfere with, disrupt, or create an undue burden on the Platform or the networks or services
connected to the Platform.
24. except as may be the result of standard search engine or Internet browser usage, use, launch,
develop, or distribute any automated system, including without limitation, any spider, robot,
cheat utility, scraper, or offline reader that accesses the Platform, or using or launching any
unauthorized script or other software.
6. Fees and Payments
Fees are charged to the User for activities performed on, or as a result of, the Platform. Fees may be
charged per transaction, such as on the completion of trades between parties are performed on the
Platform or as a direct result of activity performed on the Platform (“Brokerage Fees”). Fees may be
charged on a recurring subscription basis as directed further within the Platform (“Subscription
Fees”). You agree to pay any incurred fees as invoiced within THIRTY (30) CALENDAR DAYS of
receipt of notice of fees owing.
Brokerage Fees are owing on a per tonnage basis of delivered goods, not based on contractual
tonnage. Any tonnage that is delivered, picked up, or otherwise displaced by either the buyer or seller, or
an authorized agent of the buyer or seller, of a transaction performed as a result of activity on the
Platform, will result in Brokerage Fees being deemed earned by Johnston’s Connected regardless of
quality discounts, violations of the contracted date of movement, renegotiations, or any other disputes or
issues between the buyer and seller. In the event that a contract between users of the Platform is settled
financially due to non-performance of one party, the Brokerage Fee will remain deemed earned by
Johnston’s Connected.
7. Termination and Term
These Terms of Use shall remain in full force and effect while you use the Platform. Without limiting any
other provision of these terms of use, we reserve the right to, in our sole discretion and without notice or
liability, deny access to and use of the Platform (including blocking certain ip addresses), to any person
for any reason or for no reason, including without limitation for breach of any representation, warranty, or
covenant contained in these terms of use or of any applicable law or regulation. we may terminate your
use or participation in the Platform or delete your account and any content or information that you posted
at any time, without warning, in our sole discretion.
If we decide to terminate or suspend your account for any reason, you are thereafter prohibited from
registering and creating a new account under your name, a fake or borrowed name, or the name of any
third party, even if you may be acting on behalf of the third party. In addition to terminating or
suspending your account, as the case may be, we reserve the right to take appropriate legal action,
including but not limited to pursuing civil, criminal, and injunctive remedies or prosecution, under statute
or common law.
8. Intellectual Property Rights
Unless otherwise indicated, the Platform is our proprietary property and all source code, databases,
functionality, software, website designs, audio, video, text, photographs, and graphics on the Platform
(collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the
“Marks”) are owned or controlled by us or licensed to us. Said Marks are protected by copyright and
trademark laws and various other intellectual property rights and unfair competition laws of Canada,
foreign jurisdictions, and international conventions. The Content and the Marks are provided on the Site
“AS IS” for your information and personal use only. Except as expressly provided in these Terms of Use,
no part of the Platform and no Content or Marks may be copied, reproduced, aggregated, republished,
uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or
otherwise exploited for any commercial purpose whatsoever, without our express prior written
permission.
Provided that you are eligible to use the Platform, you are granted a limited license to access and use the
Platform and to download or print a copy of any portion of the Content to which you have properly gained
access solely for your personal, non-commercial use. We reserve all rights not expressly granted to you in
and to the Platform, Content and the Marks.
9. Mobile Application License
If you access the Platform via a mobile application, then we grant you a revocable, non-exclusive, nontransferable, limited right to install and use the mobile application on wireless electronic devices owned
or controlled by you, and to access and use the mobile application on such devices strictly in accordance
with the terms and conditions of this mobile application license contained in these Terms of Use. You
shall not: (1) decompile, reverse engineer, disassemble, attempt to derive the source code of, or decrypt
the application; (2) make any modification, adaptation, improvement, enhancement, translation, or
derivative work from the application; (3) violate any applicable laws, rules, or regulations in connection
with your access or use of the application; (4) remove, alter, or obscure any proprietary notice (including
any notice of copyright or trademark) posted by us or the licensors of the application; (5) use the
application for any revenue generating endeavor, commercial enterprise, or other purpose for which it is
not designed or intended; (6) make the application available over a network or other environment
permitting access or use by multiple devices or users at the same time; (7) use the application for creating
a product, service, or software that is, directly or indirectly, competitive with or in any way a substitute
for the application; (8) use the application to send automated queries to any website or to send any
unsolicited commercial e-mail; or (9) use any proprietary information or any of our interfaces or our other
intellectual property in the design, development, manufacture, licensing, or distribution of any
applications, accessories, or devices for use with the application.
Apple and Android Devices
The following terms apply when you use a mobile application obtained from either the Apple Store or
Google Play (each an “App Distributor”) to access the Platform: (1) the license granted to you for our
mobile application is limited to a non-transferable license to use the application on a device that utilizes
the Apple iOS or Android operating systems, as applicable, and in accordance with the usage rules set
forth in the applicable App Distributor’s terms of service; (2) we are responsible for providing any
maintenance and support services with respect to the mobile application as specified in the terms and
conditions of this mobile application license contained in these Terms of Use or as otherwise required
under applicable law, and you acknowledge that each App Distributor has no obligation whatsoever to
furnish any maintenance and support services with respect to the mobile application; (3) in the event of
any failure of the mobile application to conform to any applicable warranty, you may notify the
applicable App Distributor, and the App Distributor, in accordance with its terms and policies, may
refund the purchase price, if any, paid for the mobile application, and to the maximum extent permitted by
applicable law, the App Distributor will have no other warranty obligation whatsoever with respect to the
mobile application; (4) you represent and warrant that (i) you are not located in a country that is subject to
a U.S. government embargo, or that has been designated by the U.S. government as a “terrorist
supporting” country and (ii) you are not listed on any U.S. government list of prohibited or restricted
parties; (5) you must comply with applicable third-party terms of agreement when using the mobile
application, e.g., if you have a VoIP application, then you must not be in violation of their wireless data
service agreement when using the mobile application; and (6) you acknowledge and agree that the App
Distributors are third-party beneficiaries of the terms and conditions in this mobile application license
contained in these Terms of Use, and that each App Distributor will have the right (and will be deemed to
have accepted the right) to enforce the terms and conditions in this mobile application license contained in
these Terms of Use against you as a third-party beneficiary thereof.
10. Disclaimers and Limitation of Liability
a. Johnston’s Connected provides its services on an "as-is" and "as-available" basis. We do not warrant
that our platform will be uninterrupted, error-free, or free of viruses. b. To the fullest extent permitted by
law, Johnston’s Connected disclaims all warranties, express or implied, including but not limited to
warranties of merchantability, fitness for a particular purpose, and non-infringement. c. Johnston’s
Connected shall not be liable for any direct, indirect, incidental, special, consequential, or exemplary
damages, including but not limited to damages for loss of profits, goodwill, use, data, or other intangible
losses resulting from your use of our platform.
11. Governing Law
These Terms of Use and your use of the Platform are governed by and construed in accordance with the
laws of Province of Alberta, Canada, and applicable federal laws of Canada, as the case may be. The
parties hereby irrevocably attorn any litigation whatsoever to the courts of the City of Calgary, Alberta,
Canada. The parties may initiate legal proceedings in a different jurisdiction for the sole purpose of
enforcing an existing judgement/order of a Court of the Province of Alberta, Canada.
12. Changes to Terms
We reserves the right to update or modify these Terms of Use at any time without prior notice.
Any changes will be effective immediately upon posting on our platform. Your continued use of
Johnston’s Connected platform following the posting of changes constitutes your acceptance of
such changes.
13. Contact Us
In order to resolve a complaint regarding the Site or to receive further information regarding use of the
Site, please contact us at:
JOHNSTON’S GRAIN CONNECTED LTD.
Email: support@johnstonsconnected.com
Suite 2800, 150-9
th Avenue S.W.
Calgary, Alberta, Canada
T2P 3H9
Last updated: June 21, 2024
`;
